import React, { useState, useCallback } from 'react'
import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Button
} from '@material-ui/core'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import DeleteIcon from '@material-ui/icons/Delete'
import AddRoundedIcon from '@material-ui/icons/AddRounded'
import useStyles from './styles'
import KeywordRule from 'components/KeywordRule'


const KeywordsSet = (props) => {
  const {
    setIndex,
    rules,
    addRule,
    removeRule,
    removeSet,
    updateRule,
    isMobile
  } = props

  const localClasses = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleAddRule = (event) => {
    setAnchorEl(null)
    addRule(setIndex)
  }

  const handleRemoveSet = (event) => {
    setAnchorEl(null)
    removeSet(setIndex)
  }

  const handleClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event) => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const renderRules = useCallback(() => {
      if (!rules) {
        return null
      }
      return rules.map((rule, index) =>
        <KeywordRule
          key={`rule-${index}-set-${setIndex}`}
          rule={rule}
          removeRule={removeRule}
          setIndex={setIndex}
          updateRule={updateRule}
          ruleIndex={index}
        />
      )
    }, rules) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      className={localClasses.set}
    >
      <div className={localClasses.setsHeaders}>
        <Typography
          variant='subtitle1'
          className={localClasses.setName}
        >
          Set {setIndex + 1}
        </Typography>
        {
          isMobile ?
            <div
              className={localClasses.actions}
            >
              <IconButton
                aria-controls='keywords-menu'
                aria-haspopup='true'
                onClick={handleClick}
                className={localClasses.formControl}
              >
                <MoreHorizIcon />
              </IconButton>
              <Menu
                id='keywords-menu'
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleAddRule}>Add rule</MenuItem>
                <MenuItem onClick={handleRemoveSet}>Delete</MenuItem>
              </Menu>
            </div> :
            <div className={localClasses.actions}>
              <Button
                className={localClasses.deleteButton}
                startIcon={<DeleteIcon className={localClasses.deletesIcon} />}
                onClick={handleRemoveSet}
              >
                Delete Set
              </Button>
              <Button
                className={localClasses.addButton}
                startIcon={<AddRoundedIcon className={localClasses.plusIcon} />}
                onClick={handleAddRule}
              >
                Add keywords
              </Button>
            </div>
        }
      </div>
      <div>
        {
          renderRules()
        }
      </div>
    </div>
  )
}

export default KeywordsSet
